/**
 * Created by guntherclaes on 23/06/16.
 */

exports = module.exports = function ($stateProvider, $urlRouterProvider) {
  'use strict';

  //Redirects
  $urlRouterProvider.when('?preview&version&date', '/?preview&version&date')
    .when('/bib?preview&version&date', '/bib/illustraties?preview&version&date')
    .when('/bib', '/bib/illustraties')
    .when('/concept?preview&version&date', '/concept/krachtlijnen?preview&version&date')
    .when('/concept', '/concept/krachtlijnen')
    .when('/support', '/support/')

  //404 if state not found
    .otherwise(function ($injector) {
      $injector.get('$state').go('notFound', null, { location: false });
    });

  //Default pages
  $stateProvider
    .state('home', {
      url: '/',
      controller: 'HomeController',
      template: require('../screen/home/homePage.html')
    })
    .state('notFound', {
      url: '/404',
      template: require('../screen/notFound/notFoundPage.html')
    });

  $stateProvider
  .state('search', {
    url: '/zoeken?offset&q&types',
    controller: 'SearchController',
    template: require('../screen/search/searchPage.html')
  });

  //Concept
  $stateProvider
    .state('concept', {
      url: '/concept',
      controller: 'ConceptController',
      template: require('../screen/concept/conceptPage.html')
    })
    .state('concept.krachtlijnen', {
      controller: 'ConceptKrachtlijnenController',
      template: require('../screen/concept/krachtlijnen/conceptKrachtlijnenPage.html')
    })
    .state('concept.krachtlijnen.home', {
      url: '/krachtlijnen',
      controller: 'ConceptKrachtlijnenHomeController',
      template: require('../screen/concept/krachtlijnen/home/conceptKrachtlijnenHomePage.html')
    })
    .state('concept.krachtlijnen.view', {
      url: '/krachtlijnen/:key',
      controller: 'ConceptKrachtlijnenViewController',
      template: require('../screen/concept/krachtlijnen/view/conceptKrachtlijnenViewPage.html')
    })
    .state('concept.leeruitkomst', {
      url: '/leeruitkomst',
      controller: 'ConceptLeeruitkomstController',
      template: require('../screen/concept/leeruitkomst/conceptLeeruitkomstPage.html')
    })
    .state('concept.leeruitkomstView', {
      url: '/leeruitkomst/:key',
      controller: 'ConceptLeeruitkomstController',
      template: require('../screen/concept/leeruitkomst/conceptLeeruitkomstPage.html')
    })
    .state('concept.ordeningskader', {
      url: '/ordeningskader',
      controller: 'ConceptOrdeningskaderController',
      template: require('../screen/concept/ordeningskader/conceptOrdeningskaderPage.html')
    })
    .state('concept.ordeningskaderView', {
      url: '/ordeningskader/:key',
      controller: 'ConceptOrdeningskaderController',
      template: require('../screen/concept/ordeningskader/conceptOrdeningskaderPage.html')
    });

  //Support
  $stateProvider
    .state('support', {
      url: '/support',
      controller: 'SupportController',
      template: require('../screen/support/supportPage.html')
    })
    .state('support.view', {
      url: '/:key',
      controller: 'SupportHomeController',
      template: require('../screen/support/supportHomePage.html')
    })
    .state('support.home', {
      url: '/',
      controller: 'SupportHomeController',
      template: require('../screen/support/supportHomePage.html')
    })
    .state('support.overview', {
      url: '/overzicht',
      controller: 'SupportOverzichtController',
      template: require('../screen/support/supportOverzichtPage.html')
    })
    .state('support.leerplansite', {
      url: '/leerplansite?hoofdstuk&preview&version&date',
      reloadOnSearch: false,
      controller: 'SupportViewController',
      template: require('../screen/support/supportViewPage.html')
    })
    .state('support.selectietool', {
      url: '/selectietool?hoofdstuk&preview&version&date',
      reloadOnSearch: false,
      controller: 'SupportViewController',
      template: require('../screen/support/supportViewPage.html')
    });


  //Bib
  $stateProvider
    .state('bib', {
      url: '/bib',
      template: '<div ui-view></div>'
    })
    .state('bib.search', {
      template: require('../screen/bib/search/bibSearchPage.html'),
      controller: 'BibSearchController'
    })
    .state('bib.search.class', {
      url: '/klaspraktijk?q&goal&field&theme&ageTo&ageFrom&type&offset&preview&version&date',
      controller: 'BibSearchClassController',
      template: require('../screen/bib/search/classExamples/bibSearchClassPage.html'),
      params: {
        theme: { value: '0', squash: true},
        type: { value: '4e854b90-7f65-4f96-9b40-e161eefaa87a', squash: true}
      }
    })
    .state('bib.search.illustration', {
      url: '/illustraties?q&goal&field&theme&ageTo&ageFrom&type&offset&preview&version&date&from',
      controller: 'BibIllustrationsController',
      template: require('../screen/bib/search/illustrations/bibIllustrationsPage.html'),
      params: {
        theme: { value: '0', squash: true},
        type: { value: '4e854b90-7f65-4f96-9b40-e161eefaa87a', squash: true}
      }
    })
    .state('bib.search.term', {
      url: '/begrippen?type&field&theme&goal&q&preview&version&date',
      controller: 'BibSearchTermController',
      template: require('../screen/bib/search/term/bibSearchTermPage.html')
    })
    .state('bib.search.term.display', {
      url: '/:key?from&preview&version&date',
      controller: 'BibSearchTermDisplayController',
      template: require('../screen/bib/search/term/display/bibSearchTermDisplayPage.html')
    })
    .state('bib.search.concordanties', {
      url: '/concordanties?way&type&field&theme&goal&leergebied&domain&odetGoal&preview&version&date',
      controller: 'BibSearchConcordantiesController',
      template: require('../screen/bib/search/concordanties/bibSearchConcordantiesPage.html'),
      reloadOnSearch: true,
      params: {
        way: { value: '0', squash: true}
      }
    })
    .state('bib.search.display', {
      url: '/:key',
      controller: 'BibDisplayController',
      template: require('../screen/bib/display/bibDisplayPage.html')
    });

  //Leerinhoud
  $stateProvider
    .state('leerinhoud', {
      template: '<div ui-view></div>'
    })
    .state('leerinhoud.overview', {
      url: '/leerinhoud',
      controller: 'LeerinhoudOverviewController',
      template: require('../screen/leerinhoud/overview/leerinhoudOverviewPage.html')
    })
    .state('leerinhoud.field', {
      url: '^/leerinhoud/:fieldKey',
      controller: 'LeerinhoudFieldController',
      template: require('../screen/leerinhoud/field/leerinhoudFieldPage.html')
    })
    .state('leerinhoud.fieldMore', {
      url: '^/leerinhoud/:fieldKey/meer',
      controller: 'LeerinhoudFieldMoreController',
      template: require('../screen/leerinhoud/field/leerinhoudFieldMorePage.html')
    })
    .state('leerinhoud.theme', {
      url: '^/leerinhoud/:fieldKey/:themeKey',
      controller: 'LeerinhoudThemeController',
      template: require('../screen/leerinhoud/theme/leerinhoudthemePage.html')
    })
    .state('leerinhoud.themeMore', {
      url: '^/leerinhoud/:fieldKey/:themeKey/meer',
      controller: 'LeerinhoudThemeMoreController',
      template: require('../screen/leerinhoud/theme/leerinhoudthemeMorePage.html')
    })
    .state('leerinhoud.goal', {
      url: '^/leerinhoud/:fieldKey/:themeKey/:goalKey',
      controller: 'LeerinhoudGoalController',
      template: require('../screen/leerinhoud/goal/leerinhoudGoalPage.html')
    })
    .state('leerinhoud.goalContainer', {
      url: '^/leerinhoud/:fieldKey/:themeKey/:goalKey?containerKey&contentKey',
      controller: 'LeerinhoudGoalController',
      template: require('../screen/leerinhoud/goal/leerinhoudGoalPage.html')
    });
};



// WEBPACK FOOTER //
// ./web/js/app/routes.js